import { Schema } from 'mongoose';

const contractVersion = new Schema({
  versionNumber: {
    type: String,
    required: true,
  },
  versionName: {
    type: String,
    required: true,
  },
});

export default contractVersion;
